export enum AuthType {
  GOOGLE = 'google',
  BIOMETRICS = 'biometrics',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
}
